import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../img/Axxess_Intelligence_logo_2.svg'


const _hoisted_1 = { id: "Visit_Details" }
const _hoisted_2 = {
  key: 0,
  slot: "content",
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  slot: "content",
  id: "Find_A_Match",
  class: "task-details d-flex flex-column p-md-3"
}
const _hoisted_7 = { class: "container m-0 p-md-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Task Information", -1 /* HOISTED */)
const _hoisted_9 = {
  key: 0,
  class: "w-100"
}
const _hoisted_10 = { class: "input-group flex-md-nowrap w-100" }
const _hoisted_11 = { class: "form-group w-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "taks-name",
  class: "fw-bold"
}, [
  /*#__PURE__*/_createTextVNode("Client "),
  /*#__PURE__*/_createElementVNode("span", { class: "pe-2" })
], -1 /* HOISTED */)
const _hoisted_13 = { class: "form-group w-50" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "taks-name",
  class: "fw-bold"
}, [
  /*#__PURE__*/_createTextVNode("Is all day "),
  /*#__PURE__*/_createElementVNode("span", { class: "pe-2" })
], -1 /* HOISTED */)
const _hoisted_15 = { class: "input-group flex-md-nowrap w-100" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "form-group w-25" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "taks-name",
    class: "fw-bold"
  }, [
    /*#__PURE__*/_createTextVNode("Payer "),
    /*#__PURE__*/_createElementVNode("span", { class: "pe-2" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Caregiver 123")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "form-group w-50" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "taks-name",
  class: "fw-bold"
}, [
  /*#__PURE__*/_createTextVNode("From "),
  /*#__PURE__*/_createElementVNode("span", { class: "pe-2" })
], -1 /* HOISTED */)
const _hoisted_19 = { class: "input-group flex-md-nowrap w-100" }
const _hoisted_20 = { class: "form-group w-25" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "taks-name",
  class: "fw-bold"
}, [
  /*#__PURE__*/_createTextVNode("Task "),
  /*#__PURE__*/_createElementVNode("span", { class: "pe-2" })
], -1 /* HOISTED */)
const _hoisted_22 = { class: "form-group w-50" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "taks-name",
  class: "fw-bold"
}, [
  /*#__PURE__*/_createTextVNode("To "),
  /*#__PURE__*/_createElementVNode("span", { class: "pe-2" })
], -1 /* HOISTED */)
const _hoisted_24 = { class: "input-group flex-md-nowrap" }
const _hoisted_25 = { class: "form-group w-100" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "taks-name",
  class: "fw-bold"
}, [
  /*#__PURE__*/_createTextVNode("Tags "),
  /*#__PURE__*/_createElementVNode("span", { class: "pe-2" })
], -1 /* HOISTED */)
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Matching Options", -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 fw-normal border-bottom" }, "Caregiver Criteria", -1 /* HOISTED */)
const _hoisted_30 = { class: "table-responsive w-50" }
const _hoisted_31 = { class: "table border border-gray" }
const _hoisted_32 = { class: "bg-table-header" }
const _hoisted_33 = { class: "input-label" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Required", -1 /* HOISTED */)
const _hoisted_35 = { class: "input-label" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "Preferred", -1 /* HOISTED */)
const _hoisted_37 = { class: "input-label" }
const _hoisted_38 = ["value", "checked", "onChange"]
const _hoisted_39 = { class: "input-label" }
const _hoisted_40 = ["value", "checked", "onChange"]
const _hoisted_41 = { class: "d-flex border-bottom" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold" }, "Client Criteria", -1 /* HOISTED */)
const _hoisted_43 = {
  class: "collapse",
  id: "collapseExample"
}
const _hoisted_44 = { class: "table-responsive w-100 mt-2" }
const _hoisted_45 = { class: "table border border-gray" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
  /*#__PURE__*/_createElementVNode("th"),
  /*#__PURE__*/_createElementVNode("th", null, "License Certifications"),
  /*#__PURE__*/_createElementVNode("th", null, "Skills"),
  /*#__PURE__*/_createElementVNode("th", null, "Transfers"),
  /*#__PURE__*/_createElementVNode("th", null, "Personality Traits"),
  /*#__PURE__*/_createElementVNode("th", null, "Pets"),
  /*#__PURE__*/_createElementVNode("th", null, "General")
], -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold" }, "Required", -1 /* HOISTED */)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { key: 4 }
const _hoisted_53 = { key: 5 }
const _hoisted_54 = { key: 6 }
const _hoisted_55 = { key: 7 }
const _hoisted_56 = { key: 8 }
const _hoisted_57 = { key: 9 }
const _hoisted_58 = { key: 10 }
const _hoisted_59 = { key: 11 }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "fw-bold" }, "Desired", -1 /* HOISTED */)
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 2 }
const _hoisted_64 = { key: 3 }
const _hoisted_65 = { key: 4 }
const _hoisted_66 = { key: 5 }
const _hoisted_67 = { key: 6 }
const _hoisted_68 = { key: 7 }
const _hoisted_69 = { key: 8 }
const _hoisted_70 = { key: 9 }
const _hoisted_71 = { key: 10 }
const _hoisted_72 = { key: 11 }
const _hoisted_73 = { class: "d-flex w-100 mt-3 justify-content-between" }
const _hoisted_74 = { class: "d-flex flex-column w-45" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold border-bottom" }, "Availability", -1 /* HOISTED */)
const _hoisted_76 = { class: "input-label" }
const _hoisted_77 = ["checked"]
const _hoisted_78 = /*#__PURE__*/_createTextVNode("Full Availability ")
const _hoisted_79 = { class: "input-label" }
const _hoisted_80 = ["checked"]
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Any Availability ")
const _hoisted_82 = { class: "d-flex flex-column w-45" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold border-bottom" }, "Oriented", -1 /* HOISTED */)
const _hoisted_84 = { class: "input-label" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Yes ")
const _hoisted_86 = { class: "input-label" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode("No ")
const _hoisted_88 = {
  id: "Tags_Container",
  class: "container m-0 p-1 d-flex flex-column col-12"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold w-100 border-bottom" }, "Tags", -1 /* HOISTED */)
const _hoisted_90 = { class: "tag-option" }
const _hoisted_91 = { class: "mb-2 w-5 input-label" }
const _hoisted_92 = ["checked"]
const _hoisted_93 = /*#__PURE__*/_createTextVNode("None ")
const _hoisted_94 = { class: "d-flex align-items-center w-100 tag-option" }
const _hoisted_95 = { class: "me-1 w-5" }
const _hoisted_96 = { class: "input-label" }
const _hoisted_97 = ["checked"]
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" Any ")
const _hoisted_99 = {
  key: 0,
  class: "input-group d-flex w-20 flex-nowrap me-1"
}
const _hoisted_100 = { class: "flex-shrink-1 flex-grow-1" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("span", null, "When Any is selected, employees can have any of the tags selected to display")
], -1 /* HOISTED */)
const _hoisted_102 = { class: "d-flex align-items-center w-100 mt-2 tag-option" }
const _hoisted_103 = { class: "me-1 w-5" }
const _hoisted_104 = { class: "input-label" }
const _hoisted_105 = ["checked"]
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" All ")
const _hoisted_107 = {
  key: 0,
  class: "input-group d-flex w-20 flex-nowrap me-1"
}
const _hoisted_108 = { class: "flex-shrink-1 flex-grow-1" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "w-50" }, [
  /*#__PURE__*/_createElementVNode("span", null, "When All is selected, employees must have all of the tags selected to display")
], -1 /* HOISTED */)
const _hoisted_110 = { class: "d-flex align-items-center justify-content-center mt-4 mb-4" }
const _hoisted_111 = { class: "d-flex flex-column" }
const _hoisted_112 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold table-title" }, "Matching Results", -1 /* HOISTED */)
const _hoisted_114 = { class: "table-responsive w-100 mt-2" }
const _hoisted_115 = { class: "table border border-gray" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Caregiver"),
    /*#__PURE__*/_createElementVNode("th", null, "Distance"),
    /*#__PURE__*/_createElementVNode("th", null, "Relationship"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Required Criteria"),
    /*#__PURE__*/_createElementVNode("th", null, "Preferred Criteria"),
    /*#__PURE__*/_createElementVNode("th", null, "Tags")
  ])
], -1 /* HOISTED */)
const _hoisted_117 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_118 = ["colspan"]
const _hoisted_119 = /*#__PURE__*/_createElementVNode("h3", null, "No Matches Found", -1 /* HOISTED */)
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = { class: "table-loading" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_123 = [
  _hoisted_122
]
const _hoisted_124 = ["value", "checked", "onChange"]
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = { key: 2 }
const _hoisted_128 = { key: 3 }
const _hoisted_129 = { key: 4 }
const _hoisted_130 = { key: 5 }
const _hoisted_131 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex mt-2 me-2 justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "mb-2"
  }),
  /*#__PURE__*/_createElementVNode("button", { class: "ai-premium-btn ms-2 mt-1 mb-2" }, "Premium")
], -1 /* HOISTED */)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "ai-line" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelectDropdown = _resolveComponent("MultiSelectDropdown")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FormSection, {
      "full-height": true,
      title: "Find a Match",
      "show-background": false,
      "show-product-pill": true,
      "application-id": 2
    }, {
      content: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_5))
          : (_openBlock(), _createElementBlock("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _hoisted_8,
                  (_ctx.matchDetails)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("span", null, _toDisplayString(_ctx.matchDetails.clientName ? _ctx.matchDetails.clientName : "Unassigned"), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("span", null, _toDisplayString(_ctx.matchDetails.isAllDay ? "Yes" : "No"), 1 /* TEXT */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("span", null, _toDisplayString(_ctx.payload.startDate), 1 /* TEXT */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("span", null, _toDisplayString(_ctx.matchDetails.task), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("span", null, _toDisplayString(_ctx.payload.endDate), 1 /* TEXT */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchDetails.patientTags, (tag) => {
                              return (_openBlock(), _createElementBlock("span", {
                                value: tag,
                                class: "tag ms-2 p-1 rounded fw-bold"
                              }, _toDisplayString(tag), 9 /* TEXT, PROPS */, _hoisted_27))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_28,
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("table", _hoisted_31, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_32, [
                          _createElementVNode("th", null, [
                            _createElementVNode("div", _hoisted_33, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "me-1",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requiredAllSelected) = $event)),
                                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requiredAllSelectedChanged()))
                              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                [_vModelCheckbox, _ctx.requiredAllSelected]
                              ]),
                              _hoisted_34
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("div", _hoisted_35, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "me-1",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.preferredAllSelected) = $event)),
                                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.preferredAllSelectedChanged()))
                              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                [_vModelCheckbox, _ctx.preferredAllSelected]
                              ]),
                              _hoisted_36
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caregiver, (data) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  class: "me-1",
                                  value: data.key,
                                  checked: _ctx.checkRequiredMatches(data.key),
                                  onChange: ($event: any) => (_ctx.requiredSelectionChanged(data.key))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_38),
                                _createElementVNode("span", null, _toDisplayString(data.name), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  class: "me-1",
                                  value: data.key,
                                  checked: _ctx.checkpreferredMatches(data.key),
                                  onChange: ($event: any) => (_ctx.preferredSelectionChanged(data.key))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_40),
                                _createElementVNode("span", null, _toDisplayString(data.name), 1 /* TEXT */)
                              ])
                            ])
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("a", {
                      class: "ms-2 cursor-pointer text-decoration-none",
                      "data-bs-toggle": "collapse",
                      href: "#collapseExample",
                      "aria-expanded": "false",
                      "aria-controls": "collapseExample",
                      role: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.show = !_ctx.show))
                    }, _toDisplayString(_ctx.show ? "Hide" : "View"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("table", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("tr", null, [
                          _hoisted_47,
                          (_ctx.requiredCriteria['License/Certifications'].length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_48, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_49, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredCriteria['License/Certifications'], (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.requiredCriteria.Skills.length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_50, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_51, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredCriteria.Skills, (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.requiredCriteria.Transfers.length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_52, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_53, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredCriteria.Transfers, (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.requiredCriteria['Personality Traits'].length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_54, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_55, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredCriteria['Personality Traits'], (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.requiredCriteria.Pets.length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_56, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_57, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredCriteria.Pets, (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.requiredCriteria.General.length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_58, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_59, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requiredCriteria.General, (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ]))
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_60,
                          (_ctx.desiredCriteria['License/Certifications'].length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_61, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_62, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desiredCriteria['License/Certifications'], (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.desiredCriteria.Skills.length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_63, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_64, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desiredCriteria.Skills, (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.desiredCriteria.Transfers.length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_65, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_66, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desiredCriteria.Transfers, (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.desiredCriteria['Personality Traits'].length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_67, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_68, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desiredCriteria['Personality Traits'], (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.desiredCriteria.Pets.length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_69, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_70, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desiredCriteria.Pets, (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])),
                          (_ctx.desiredCriteria.General.length === 0)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_71, "--"))
                            : (_openBlock(), _createElementBlock("td", _hoisted_72, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.desiredCriteria.General, (data) => {
                                  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(data.description), 1 /* TEXT */))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ]))
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("label", _hoisted_76, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "me-1",
                        value: 1,
                        checked: _ctx.availability == 1,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.availability) = $event))
                      }, null, 8 /* PROPS */, _hoisted_77), [
                        [_vModelRadio, _ctx.availability]
                      ]),
                      _hoisted_78
                    ]),
                    _createElementVNode("label", _hoisted_79, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "me-1",
                        value: 2,
                        checked: _ctx.availability == 2,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.availability) = $event))
                      }, null, 8 /* PROPS */, _hoisted_80), [
                        [_vModelRadio, _ctx.availability]
                      ]),
                      _hoisted_81
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("label", _hoisted_84, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "me-1",
                        value: true,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isOriented) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelRadio, _ctx.isOriented]
                      ]),
                      _hoisted_85
                    ]),
                    _createElementVNode("label", _hoisted_86, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "me-1",
                        value: false,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isOriented) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelRadio, _ctx.isOriented]
                      ]),
                      _hoisted_87
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("label", _hoisted_91, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        class: "me-1",
                        value: 0,
                        checked: _ctx.tagsOptions === 0,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tagsOptions) = $event)),
                        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.tagOptionsChanged(0)))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_92), [
                        [_vModelRadio, _ctx.tagsOptions]
                      ]),
                      _hoisted_93
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("label", _hoisted_96, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "me-1",
                          value: 1,
                          checked: _ctx.tagsOptions === 1,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tagsOptions) = $event)),
                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.tagOptionsChanged(1)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_97), [
                          [_vModelRadio, _ctx.tagsOptions]
                        ]),
                        _hoisted_98
                      ])
                    ]),
                    (_ctx.matchDetails)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          _createElementVNode("div", _hoisted_100, [
                            _createVNode(_component_MultiSelectDropdown, {
                              name: "any",
                              disabled: _ctx.tagsOptions !== 1,
                              options: _ctx.matchDetails.employeeTags,
                              "selected-items": _ctx.anyUserTags,
                              onSelectedItemsUpdated: _ctx.anyUserTagsUpdated,
                              "has-actions": true
                            }, null, 8 /* PROPS */, ["disabled", "options", "selected-items", "onSelectedItemsUpdated"])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _hoisted_101
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("label", _hoisted_104, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "me-1",
                          value: 2,
                          checked: _ctx.tagsOptions === 2,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tagsOptions) = $event)),
                          onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.tagOptionsChanged(2)))
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_105), [
                          [_vModelRadio, _ctx.tagsOptions]
                        ]),
                        _hoisted_106
                      ])
                    ]),
                    (_ctx.matchDetails)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                          _createElementVNode("div", _hoisted_108, [
                            _createVNode(_component_MultiSelectDropdown, {
                              name: "all",
                              disabled: _ctx.tagsOptions !== 2,
                              options: _ctx.matchDetails.employeeTags,
                              "selected-items": _ctx.allUserTags,
                              onSelectedItemsUpdated: _ctx.allUserTagsUpdated,
                              "has-actions": true
                            }, null, 8 /* PROPS */, ["disabled", "options", "selected-items", "onSelectedItemsUpdated"])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _hoisted_109
                  ])
                ]),
                _createElementVNode("div", _hoisted_110, [
                  _createElementVNode("button", {
                    class: "btn btn-primary me-2",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.findAMatch()))
                  }, "Find"),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeFindMatch()))
                  }, "Cancel")
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _hoisted_113,
                    _createElementVNode("button", {
                      class: "btn btn-primary mb-1",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sendMatchMessage()))
                    }, "Send Message")
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("table", _hoisted_115, [
                      _hoisted_116,
                      _createElementVNode("tbody", null, [
                        _createCommentVNode(" EMPTY "),
                        (!_ctx.findingMatches && _ctx.matchingResults.length === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_117, [
                              _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_120, 8 /* PROPS */, _hoisted_118)
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.findingMatches)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.columns, (i) => {
                              return (_openBlock(), _createElementBlock("tr", _hoisted_121, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                                  return (_openBlock(), _createElementBlock("td", null, _hoisted_123))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (!_ctx.findingMatches && _ctx.matchingResults.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.matchingResults, (data) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    model: "data.userId",
                                    value: data.userId,
                                    checked: _ctx.checkUserIds(data.userId),
                                    onChange: ($event: any) => (_ctx.userIdsChanged(data.userId))
                                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_124)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(data.displayName), 1 /* TEXT */),
                                _createElementVNode("td", null, _toDisplayString(data.distance), 1 /* TEXT */),
                                _createElementVNode("td", null, _toDisplayString(data.relationship), 1 /* TEXT */),
                                _createElementVNode("td", null, _toDisplayString(data.phoneNumber), 1 /* TEXT */),
                                (data.requiredMatches.length === 0)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_125, "No Criteria Matched"))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_126, _toDisplayString(data.requiredMatches.length), 1 /* TEXT */)),
                                (data.preferredMatches.length === 0)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_127, "No Criteria Matched"))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_128, _toDisplayString(data.preferredMatches.length), 1 /* TEXT */)),
                                (data.tags.length === 0)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_129, "No Tags"))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_130, _toDisplayString(data.tags.length), 1 /* TEXT */))
                              ]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("button", {
                    class: "btn btn-primary me-2",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleCaregiverSelection()))
                  }, " Use Selected Match "),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.closeFindMatch()))
                  }, "Cancel")
                ])
              ])
            ]))
      ]),
      content_2: _withCtx(() => [
        _hoisted_132,
        _hoisted_133
      ]),
      _: 1 /* STABLE */
    })
  ]))
}